export const horizontalScroll = (() => {
	const init = () => {
		const horizontalScrolls = document.querySelectorAll("[data-horizontal-scroll]");
		horizontalScrolls.forEach((horizontalScroll) => {
			let spaceHolder = horizontalScroll.querySelector(".cards-slider");
			let horizontal = horizontalScroll.querySelector(".cards-slider__wrapper");
			const sticky = horizontalScroll.querySelector(".cards-slider__overflow");
			const cards = horizontal.querySelectorAll(".card");
			let cards_position = [];
			let lastScrollTop = 0;

			spaceHolder.style.height = `${calcHeight(horizontal) + calcBleed(spaceHolder)}px`;
			sticky.style.setProperty("--_hs-height", `${horizontal.offsetHeight}px`);

			cards.forEach((card, index) => {
				if (index >= 2) card.classList.add("is-blur");
			});

			window.addEventListener("scroll", () => {
				spaceHolder.style.height = `${calcHeight(horizontal) + calcBleed(spaceHolder)}px`;

				horizontal.style.transform = `translateX(-${sticky.offsetTop}px)`;

				cards.forEach((card, index) => {
					cards_position[index] = card.offsetLeft + card.offsetWidth / 2;
				});
				cards_position = cards_position.slice(0, cards_position.length - 2);

				var st = window.pageYOffset || document.documentElement.scrollTop;
				let scrollingDown = st > lastScrollTop ? true : false;
				lastScrollTop = st <= 0 ? 0 : st;

				if (scrollingDown) {
					cards_position.forEach((position, i) => {
						if (sticky.offsetTop >= position) {
							cards[i].classList.add("is-blur");
							if (cards[i + 2] !== undefined) cards[i + 2].classList.remove("is-blur");
						}
					});
				} else {
					cards_position.reverse().forEach((position, i) => {
						if (sticky.offsetTop <= position) {
							cards[cards_position.length - i - 1].classList.remove("is-blur");
							if (cards[cards_position.length - i + 1] !== undefined) cards[cards_position.length - i + 1].classList.add("is-blur");
						} else {
							cards[cards_position.length - i - 1].classList.add("is-blur");
						}
					});
				}
			});

			window.addEventListener("resize", () => {
				spaceHolder.style.height = `${calcHeight(horizontal) + calcBleed(spaceHolder)}px`;
				sticky.style.setProperty("--_hs-height", `${horizontal.offsetHeight}px`);
			});
		});

		function calcHeight(ref) {
			let objectWidth = 0;
			const cards = ref.querySelectorAll(".card");
			cards.forEach((card) => {
				objectWidth += card.offsetWidth + parseFloat(getComputedStyle(card).marginLeft);
			});

			return objectWidth;
		}

		function calcBleed(ref) {
			return parseFloat(getComputedStyle(ref).marginInlineEnd);
		}
	};

	return {
		init,
	};
})();
